import { Type } from 'class-transformer';
import { Field } from './field';
import { Model, BaseType } from './model';
import type { AuthType } from './types';
import type { FieldType, FieldFormat } from './field';

export type IntegrationCategoryType = 'accounting' | 'crm' | 'marketing-automation';

export interface CashAppIntegrationFeatures {
  can_unpost_payment: boolean;
  can_post_on_account_payment: boolean;
}

export class Integration extends Model {
  api_base_url: string | null;

  api_documentation_url: string | null;

  connection_guide_url: string | null;

  connection_instructions: string[] | null;

  api_requires_subdomain: boolean;

  api_requires_username: boolean;

  auth_type: AuthType | null;

  categories: IntegrationCategoryType[];

  cash_app_features: CashAppIntegrationFeatures;

  @Type(() => IntegrationStep)
  connection_steps: IntegrationStep[];

  color: string | null;

  description: string | null;

  display_name: string;

  is_api_key_supported: boolean;

  is_email_provider: boolean;

  is_oauth_supported: boolean;

  is_supported: boolean;

  logo: string;

  logo_square: string;

  name: string;

  @Type(() => IntegrationSetting)
  settings: IntegrationSetting[];

  short_description: string;

  website: string | null;

  get requiresAuth(): boolean {
    return Boolean(this.auth_type);
  }
}

export class IntegrationSetting extends BaseType {
  key: string;

  @Type(() => IntegrationSettingChoice)
  choices: IntegrationSettingChoice[];

  description: string;

  format: FieldFormat;

  is_editable: boolean;

  is_required: string;

  is_select: boolean;

  guide_label: string | null;

  guide_url: string | null;

  label: string;

  post_auth: boolean;

  requires_load: boolean;

  type: FieldType;
}

export class IntegrationSettingChoice extends BaseType {
  label: string;

  value: string;
}

export class IntegrationStep extends BaseType {
  type: 'form' | 'fetch' | 'quickbooks-desktop';

  endpoint: string | null;

  description: string | null;

  @Type(() => IntegrationStepFormField)
  fields: IntegrationStepFormField[];

  post_auth: boolean;

  title: string;
}

export class IntegrationStepFormField extends BaseType {
  setting: string;
}
